export default __webpack_public_path__ + "static/media/R7.8bdaade3.png";